<template>
  <w-sliding-popup type="full" ref="slidingPopup" :title="popupTitle" width="1300px" @close="closePopup">
    <div slot="content">
      <el-form :ref="formName" :model="kedbInfo" :rules="rules" label-position="top">
        <el-form-item label="제목" prop="title">
          <el-input v-model="kedbInfo.title"></el-input>
        </el-form-item>
      </el-form>
      <el-collapse class="square-icon" v-model="kedbInfoCollapse">
        <el-collapse-item title="장애 증상" name="errSymptomView">
          <div>
            <quill-editor class="kedb" ref="errSymptomView" v-model="errSymptom" :options="symptomEditorOption"></quill-editor>
          </div>
        </el-collapse-item>
        <el-collapse-item class="mr-b10" title="조치 방법" name="errSolutionView">
          <div>
            <quill-editor class="kedb" ref="errSolutionView" v-model="errSolution" :options="solutionEditorOption"></quill-editor>
          </div>
          <div>
            <el-row class="mr-t10 title-bar" type="flex" justify="space-between">
              <div class="title-h4">첨부 파일 목록</div>
              <el-upload :file-list="fileRawList" :auto-upload="false" :on-change="changeUploadFile" :before-upload="(file) => file" action="" :show-file-list="false">
                <el-button class="title-bar" type="secondary" size="mini">파일 업로드</el-button>
              </el-upload>
            </el-row>
            <el-table-wrapper :data="attachFileList" :columns="attachFileColumns"
             :show-custom-header="false" :show-search-tool="false" style="width:100%;" :pagination="false" :column-default="columnDefault">
               <template slot-scope="scope" slot="delete-slot">
                 <i class="far fa-times c-pointer" @click="deleteAttachFileInfo(scope.row)"></i>
               </template>
            </el-table-wrapper>
          </div>
        </el-collapse-item>
        <el-collapse-item title="연관장애 티켓" name="troubleTicketView">
          <el-row class="title-bar mr-t10" type="flex" justify="end">
            <el-button size="mini" type="primary" @click="addRelationTroubleTicket">추가</el-button>
          </el-row>
          <el-table-wrapper class="mr-t10" ref="relationTroubleTable" :data="relationTroubleList" :columns="relationTroubleColumns"
           :show-custom-header="false" :show-search-tool="false" style="width:100%;" :pagination="false" :column-default="columnDefault">
           <template slot-scope="scope" slot="delete-slot">
             <i class="far fa-times c-pointer" @click="deleteTroubleTicket(scope.row)"></i>
           </template>
           <template slot-scope="scope" slot="trouble-ticket-group-id-slot">
             <span class="link c-pointer" @click="clickTroubleTicketGroupId(scope.row.troubleTicketGroupId)">{{scope.row.subject}}</span>
           </template>
          </el-table-wrapper>
        </el-collapse-item>
        <el-collapse-item title="연관 자원" name="kedbRscView">
          <el-row class="title-bar vertical-center-box" type="flex" justify="start">
            <el-select class="mr-r4" v-model="managetypeId" style="width:170px;">
              <el-option v-for="item in managetypeList" :key="item.managetypeId" :label="item.managetypeName" :value="item.managetypeId"></el-option>
            </el-select>
            <el-select class="mr-r4" v-if="managetypeId==='NMS'||managetypeId==='FMS'||managetypeId==='DBMS'||managetypeId==='VMS'" v-model="managetypeKey" style="width:140px;">
              <el-option v-for="item in managetypeKeyList" :key="item.managetypeKey" :label="item.managetypeKeyName" :value="item.managetypeKey"></el-option>
            </el-select>
            <el-select class="mr-r4" v-model="rsctypeRscId" style="width:300px;" autocomplete filterable>
              <el-option v-for="item in rscInfoData" :key="item.rscInfoKey" :label="item.comboLabel" :value="item.rscInfoKey"></el-option>
            </el-select>
            <el-button size="mini" type="primary" @click="addRelationRsc">추가</el-button>
          </el-row>
          <el-table :data="relationRscData" :showHeader="false" :pagination="false" style="width:100%;">
            <el-table-column prop="label" label="자원정보" sortable></el-table-column>
            <el-table-column label="삭제" width="55">
              <template slot-scope="scope">
                <i class="far fa-times c-pointer" @click="deleteRscInfo(scope.row)"></i>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
      <w-relation-trouble-ticket-popup ref="relationTroublePopup" @selection-ticket="selectionTicketInfo"></w-relation-trouble-ticket-popup>
      <w-event-ticket-status-popup ref="statusPop" :isReadOnlyTicket="true" :trouble-ticket-info="troubleTicketInfo"></w-event-ticket-status-popup>
    </div>
    <el-row slot="footer" type="flex" justify="center">
      <el-button size="large" class="mr-r4" type="solid" @click="saveKedbInfo">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </el-row>
  </w-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import { COMMON_KEY } from '@/constants/managetype-key';
import { mapGetters } from 'vuex';
import { quillEditor } from 'vue-quill-editor';
import { EMPTY_TEXT } from '@/utils/string';
import { checkFileSize, getFileNameExceptExtension, isUnauthorizedFile } from '@/utils/file';
import { columnDefault } from '@/constants/table';
import { DUPLICATE_MESSAGE, MSG_UPLOAD_UNAUTHORIZED_FILE } from '@/constants/file';
import { isNil, isEqual, cloneDeep, find, remove, findIndex, unionBy, forEach, isEmpty } from 'lodash';
import ManagetypeKeyAPI from '@/api/model/managetype-key';
import KedbAPI from '@/api/event/kedb';
import { getDateToString } from '@/utils/date';
import WRelationTroubleTicketPopup from './RelationTroubleTicketPopup';

export default {
  name: 'WKedbAddPopup',
  components: {
    quillEditor,
    WRelationTroubleTicketPopup,
    WEventTicketStatusPopup: () => import('@/views/event/components/popup/EventTicketStatusPopup'),
  },
  props: {
    kedbDetailInfo: {
      type: Object,
      default: () => {},
    },
    popupType: {
      type: String,
    },
  },
  data() {
    return {
      columnDefault,
      isPopupOpen: false,
      formName: 'kedbSettingForm',
      // 기본 collapse 오픈
      kedbInfoCollapse: ['errSymptomView', 'errSolutionView', 'troubleTicketView', 'kedbRscView'],
      // 연관 자원 selection v-model 정의
      managetypeId: null,
      managetypeKey: null,
      managetypeIdKey: null,
      rsctypeRscId: null,
      // TextEditor 설정
      errSymptom: '',
      errSolution: '',
      // 첨부파일 목록 데이터
      attachFileList: [],
      // 첨부파일 실데이터
      originAttachList: [],
      fileRawList: [],
      relationTroubleList: [],
      originRelationTroubleList: [],
      relationRscData: [],
      rscInfoData: [],
      troubleTicketInfo: null,
      kedbInfo: {
        title: null,
      },
      rules: {
        title: { required: true, trigger: 'blur', message: '값을 입력해주세요' },
      },
      relationTroubleColumns: [
        { prop: 'troubleTicketGroupId', width: '55', label: 'No', sortable: true },
        { prop: 'subject', scopedSlot: 'trouble-ticket-group-id-slot', label: '장애티켓 제목', sortable: true },
        { label: '삭제', width: '55', scopedSlot: 'delete-slot' },
      ],
      attachFileColumns: [
        { prop: 'attachFilename', label: '파일명', sortable: true },
        { prop: 'managerId', label: '등록자', sortable: true },
        { prop: 'registDatetime', label: '등록일시', sortable: true, formatter: this.getDateFormatter },
        { label: '삭제', width: '55', scopedSlot: 'delete-slot' },
      ],
      managetypeKeyList: [],
      // TextEditor 옵션
      symptomEditorOption: {
        modules: {
          toolbar: [
            [{ 'size': ['small', false, 'large'] }],
            ['bold', 'italic'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['image'],
          ],
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false,
          },
        },
        placeholder: '장애 증상을 입력해 주십시오.',
      },
      solutionEditorOption: {
        modules: {
          toolbar: [
            [{ 'size': ['small', false, 'large'] }],
            ['bold', 'italic'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['image'],
          ],
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false,
          },
        },
        placeholder: '장애 조치를 입력해 주십시오.',
      },
    };
  },
  watch: {
    /**
     * 팝업의 형태가 수정인 경우 전달되는 props이며
     * 해당 내용이 있는 경우 팝업에 셋팅한다.
     */
    kedbDetailInfo: {
      immediate: true,
      handler(value) {
        if (!isEmpty(value) && this.isPopupOpen) {
          this.settingKedbForm();
        }
      },
    },
    managetypeId: {
      immediate: true,
      handler(value) {
        if (!isNil(value)) {
          this.managetypeKey = null;
          ManagetypeKeyAPI.getDisplayedManagetypeKeyList(value).then((response) => {
            if (response.data.success) {
              if ((isEqual(value, 'NMS') || isEqual(value, 'FMS') || isEqual(value, 'DBMS') || isEqual(value, 'VMS'))) {
                this.managetypeKeyList = response.data.data;
                this.managetypeKey = this.managetypeKeyList[0].managetypeKey;
              } else {
                this.managetypeKey = COMMON_KEY;
              }
            } else {
              this.managetypeKeyList = [];
              this.managetypeKey = null;
            }
          }).catch(() => {
            this.managetypeKeyList = [];
            this.managetypeKey = null;
          });
        }
      },
    },
    managetypeKey: {
      immediate: true,
      handler(value) {
        if (value) {
          if (!isNil(this.managetypeId) && !isNil(this.managetypeKey)) {
            this.loadRscInfoList();
          }
        }
      },
    },
  },
  computed: {
    managetypeList() {
      return this.$store.getters.activeManagetypesToShowForRsc;
    },
    popupTitle() {
      return (this.popupType === 'UPDATE') ? 'KEDB 수정' : 'KEDB 추가';
    },
    ...mapGetters(['userInfo']),
  },
  methods: {
    /**
     * 팝업이 닫힌 후 설정되어있는 모델 정보를 초기화한다.
     * @author yelim
     */
    close() {
      this.$refs.slidingPopup.visible = false;
      this.initModel();
    },
    /**
     * 팝업이 닫힌 후 설정되어있는 모델 정보를 초기화한다.
     * @author yelim
     */
    closePopup() {
      this.initModel();
    },
    /**
     * KEDB 추가 / 수정 팝업을 오픈 후 수행되는 함수.
     * @author yelim
     */
    open() {
      // 추가인 경우
      this.isPopupOpen = true;
      this.managetypeId = this.managetypeList[0].managetypeId;
      this.$refs.slidingPopup.open();
    },
    /**
     * 팝업을 닫을 경우 변수 초기화
     * @author yelim
     */
    initModel() {
      this.isPopupOpen = false;
      this.kedbInfo.title = null;
      this.errInfo = ['errSymptomView', 'errSolutionView'];
      this.kedbTroubleRscInfo = ['troubleTicketView', 'kedbRscView'];
      // 에디터에 작성된 텍스트 초기화
      this.$refs.errSymptomView.quill.setContents([]);
      this.$refs.errSolutionView.quill.setContents([]);
      // 첨부파일 관련 데이터 초기화
      this.fileRawList = [];
      this.attachFileList = [];
      this.relationTroubleList = [];
      this.managetypeId = null;
      this.managetypeKey = null;
      this.rsctypeRscId = null;
      this.relationRscData = [];
      this.originAttachList = [];
    },
    /**
     * managetypeId에 따른 rsc정보를 로드한다.
     * @author yelim
     */
    loadRscInfoList() {
      if (!isNil(this.managetypeId) && !isNil(this.managetypeKey)) {
        const managetypeId = this.managetypeId;
        const managetypeKey = this.managetypeKey;
        KedbAPI.getRscInfo({ managetypeId, managetypeKey }).then((response) => {
          if (response.data.success) {
            const resultData = response.data.data;
            this.rscInfoData = cloneDeep(resultData);
            this.rsctypeRscId = resultData[0].rscInfoKey;
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '자원 정보', false));
          }
        });
      }
    },
    /**
     * 자원 그리드에 정보를 추가한다.
     * @author yelim
     */
    addRelationRsc() {
      if (!isNil(this.rsctypeRscId)) {
        const addRacInfo = this.rsctypeRscId;
        const selectRscInfo = find(this.rscInfoData, { rscInfoKey: addRacInfo });
        if (find(this.relationRscData, { rscInfoKey: addRacInfo })) {
          this.$message(msgUtil.getCustomMsgData('이미 목록에 추가된 자원입니다.'));
        } else {
          this.relationRscData.push(selectRscInfo);
        }
      }
    },
    /**
     * 연관장애 목록에서 해당 row를 삭제한다.
     * @author yelim
     */
    deleteRscInfo(row) {
      const originRscData = cloneDeep(this.relationRscData);
      remove(originRscData, ((item) => {
        if (item.rscInfoKey === row.rscInfoKey) {
          return true;
        }
        return false;
      }));
      this.relationRscData = originRscData;
    },
    /**
     * 연관장애티켓을 추가하기 위한 팝업을 오픈한다.
     * @author yelim
     */
    addRelationTroubleTicket() {
      this.$refs.relationTroublePopup.open();
    },
    /**
     * 연관 장애티켓 추가 팝업에서 선택한 항목을 KEDB 연관 장애티켓 리스트에 추가한다.
     * @author yelim
     */
    selectionTicketInfo(tickets) {
      if (tickets.length > 0) {
        const addTicketData = cloneDeep(tickets);
        const originData = cloneDeep(this.relationTroubleList);
        const returnList = unionBy(originData, addTicketData, 'troubleTicketGroupId');
        this.relationTroubleList = returnList;
        this.$refs.relationTroublePopup.close();
      } else {
        this.$message(msgUtil.getCustomMsgData('장애티켓 항목을 선택해주십시오.'));
      }
    },
    clickTroubleTicketGroupId(troubleTicketGroupId) {
      this.troubleTicketInfo = { troubleTicketGroupId };
      this.$refs.statusPop.open();
    },
    /**
     * 추가한 연관 장애티켓 목록에서 항목을 삭제한다.
     * @author yelim
     */
    deleteTroubleTicket(row) {
      const originRscData = cloneDeep(this.relationTroubleList);
      remove(originRscData, ((item) => {
        if (item.troubleTicketGroupId === row.troubleTicketGroupId) {
          return true;
        }
        return false;
      }));
      this.relationTroubleList = originRscData;
    },
    /**
     * 파일 업로드 기능을 수행한다. - 비인가 확장자 파일 업로드 불가능 기능 추가
     * @author yelim -> NaJY
     */
    changeUploadFile(item) {
      // 비인가 확장자 파일인 경우 업로드 불가능
      if (isUnauthorizedFile(item)) {
        this.$message(msgUtil.getCustomResultMsgData(MSG_UPLOAD_UNAUTHORIZED_FILE, false));
        return;
      }
      const currentTime = new Date();
      const ableFileSizeInfo = checkFileSize(item.raw.size);
      const fileName = getFileNameExceptExtension(item.raw.name);
      if (findIndex(this.attachFileList, ['attachFilename', fileName]) > -1) {
        this.$message(msgUtil.getCustomMsgData(DUPLICATE_MESSAGE));
        return;
      }
      if (!ableFileSizeInfo.enable) {
        this.$message(msgUtil.getCustomMsgData(ableFileSizeInfo.message));
      } else {
        const fileInfo = {
          rawFile: item.raw,
          attachFilename: fileName,
          managerId: this.userInfo.managerId,
          registDatetime: currentTime,
        };
        // 리스트에 뿌려질 데이터를 담는다.
        this.attachFileList.push(fileInfo);
        // 업로드할 실 데이터를 담는다.
        this.fileRawList.push(item.raw);
      }
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    /**
     * KEDB 정보를 저장한다.
     * @author yelim
     */
    saveKedbInfo() {
      this.$refs.kedbSettingForm.validate((valid) => {
        if (valid) {
          const errSymptom = this.$refs.errSymptomView.quill.getText();
          const errSolution = this.$refs.errSolutionView.quill.getText();
          if (this.errSymptom.length > 0 && this.errSolution.length > 0) {
            const formParams = new FormData();
            const kedbInfo = {
              title: this.kedbInfo.title,
              errorSymptomRaw: this.errSymptom,
              errorSolutionRaw: this.errSolution,
              errorSymptom: errSymptom,
              errorSolution: errSolution,
              writerId: this.userInfo.managerId,
            };
            if (this.popupType === 'UPDATE') {
              kedbInfo.seqNumber = this.kedbDetailInfo.kedbInfo.seqNumber;
            }
            formParams.append('managerId', this.userInfo.managerId);
            formParams.append('kedbInfo', JSON.stringify(kedbInfo));
            // kedb와 연결된 자원이 있는 경우 파라미터에 추가
            if (this.relationRscData.length > 0) {
              formParams.append('rscInfoList', JSON.stringify(this.relationRscData));
            }
            // kedb에 등록된 첨부파일이 있는 경우 파라미터에 추가
            if (this.fileRawList.length > 0) {
              forEach(this.fileRawList, (value, index) => {
                formParams.append(`file${index}`, value);
              });
            }
            // 팝업의 종류가 추가팝업인 경우, 수정 팝업인 경우 분기처리하여 수행
            if (this.popupType === 'ADD') {
              formParams.append('insertList', JSON.stringify(this.compareAttachFileChangeList('insert')));
              if (this.relationTroubleList.length > 0) {
                formParams.append('insertTicketList', JSON.stringify(this.relationTroubleList));
              }
              KedbAPI.addKedbInfo(formParams).then((response) => {
                const result = response.data;
                if (result.success) {
                  this.close();
                  this.$emit('reload');
                  this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, 'KEDB', true));
                } else {
                  this.$message(msgUtil.getCustomResultMsgData(response.data.message, false));
                }
              }).catch(() => {
                this.$message(msgUtil.getResultMsgData(msgUtil.action.ADD, 'KEDB', false));
              });
            } else {
              formParams.append('insertList', JSON.stringify(this.compareAttachFileChangeList('insert')));
              formParams.append('deleteList', JSON.stringify(this.compareAttachFileChangeList('delete')));
              formParams.append('insertTicketList', JSON.stringify(this.compareTroubleChangeList('insert')));
              formParams.append('deleteTicketList', JSON.stringify(this.compareTroubleChangeList('delete')));
              KedbAPI.updateKedbInfo(formParams).then((response) => {
                if (response.data.success) {
                  this.close();
                  this.$emit('reload');
                  this.$message(msgUtil.getResultMsgData(msgUtil.action.EDIT, 'KEDB', true));
                } else {
                  this.$message(msgUtil.getCustomResultMsgData(response.data.message, false));
                }
              }).catch(() => {
                this.$message(msgUtil.getResultMsgData(msgUtil.action.EDIT, 'KEDB', false));
              });
            }
          } else {
            this.$message(msgUtil.getCustomMsgData('데이터를 확인해 주십시오.'));
          }
        } else {
          this.$message(msgUtil.getCustomMsgData('데이터를 확인해 주십시오.'));
        }
      });
    },
    /**
     * KEDB 수정 팝업인 경우 팝업에 수정할 데이터를 셋팅한다.
     * @author yelim
     */
    settingKedbForm() {
      const kedbDetailInfo = cloneDeep(this.kedbDetailInfo);
      if (!isEmpty(kedbDetailInfo)) {
        this.kedbInfo.title = kedbDetailInfo.kedbInfo.title;
        // 에디터에 raw데이터 바인딩
        this.errSymptom = kedbDetailInfo.kedbInfo.errorSymptomRaw;
        this.errSolution = kedbDetailInfo.kedbInfo.errorSolutionRaw;
        this.attachFileList = cloneDeep(kedbDetailInfo.kedbAttachInfo);
        this.originAttachList = cloneDeep(kedbDetailInfo.kedbAttachInfo);
        this.relationTroubleList = cloneDeep(kedbDetailInfo.kedbTroubleTicketInfo);
        // 추가된 장애티켓, 삭제된 장애티켓을 확인하기 위함
        this.originRelationTroubleList = cloneDeep(kedbDetailInfo.kedbTroubleTicketInfo);
        this.relationRscData = cloneDeep(kedbDetailInfo.kedbRscInfo);
      }
    },
    /**
     * 첨부파일 목록에서 항목을 삭제한다.
     * @author yelim
     */
    deleteAttachFileInfo(row) {
      const originFileData = cloneDeep(this.attachFileList);
      const rawFileData = cloneDeep(this.fileRawList);
      remove(originFileData, ((item) => {
        if (item.attachFilename === row.attachFilename) {
          return true;
        }
        return false;
      }));
      remove(rawFileData, ((item) => {
        if (row.rawFile && item.name === row.rawFile.name) {
          return true;
        }
        return false;
      }));
      this.attachFileList = originFileData;
      this.fileRawList = rawFileData;
    },
    /**
     * 첨부파일 관련하여 추가/삭제된 항목인지를 판단하여 값을 리턴한다.
     * @author yelim
     */
    compareAttachFileChangeList(type) {
      const returnList = [];
      const originData = this.originAttachList;
      if (type === 'insert') {
        this.attachFileList.forEach((item) => {
          const findIdx = findIndex(originData, (i) => i.attachFilename === item.attachFilename);
          if (findIdx === -1) {
            returnList.push({ attachFilename: item.attachFilename });
          }
        });
      } else {
        originData.forEach((item) => {
          const findIdx = findIndex(this.attachFileList, (i) => i.attachFilename === item.attachFilename);
          if (findIdx === -1) {
            returnList.push(item);
          }
        });
      }
      return returnList;
    },
    /**
     * 장애티켓 관련하여 추가/삭제된 항목인지를 판단하여 값을 리턴한다.
     * @author yelim
     */
    compareTroubleChangeList(type) {
      const returnList = [];
      const seqNumber = this.kedbDetailInfo.kedbInfo.seqNumber;
      const originData = this.originRelationTroubleList;
      if (type === 'insert') {
        this.relationTroubleList.forEach((item) => {
          const findIdx = findIndex(originData, (i) => i.troubleTicketGroupId === item.troubleTicketGroupId);
          if (findIdx === -1) {
            returnList.push({ troubleTicketGroupId: item.troubleTicketGroupId, seqNumber });
          }
        });
      } else {
        originData.forEach((item) => {
          const findIdx = findIndex(this.relationTroubleList, (i) => i.troubleTicketGroupId === item.troubleTicketGroupId);
          if (findIdx === -1) {
            returnList.push({ troubleTicketGroupId: item.troubleTicketGroupId, seqNumber });
          }
        });
      }
      return returnList;
    },
  },
};
</script>

<style>
.ql-editor {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/event/kedb/components/popup/KedbAddPopup.vue